export default __webpack_public_path__ + "device_alarm_base_station.bd208955.png";